module.exports = __webpack_public_path__ + "img/desc.ddbec395.png";